////
/// ============================================================================
/// COMPONENT / Automatic YouTube Gallery
/// ============================================================================
///
/// Personalizzo la slide delle video testimonianze in modo da visualizzare
/// solo 3 video su desktop, 2 su tablet e 1 su mobile.
///
/// @group components
////

let responsiveOption = [
    {
        breakpoint: 1024, // Tablet
        settings: {
            slidesToShow: 2
        }
    },
    {
        breakpoint: 768, // Mobile
        settings: {
            slidesToShow: 1
        }
    },
    {
        breakpoint: 480, // Mobile
        settings: {
            slidesToShow: 1
        }
    }
];

export default () => {
    /**
     * Anche se questo script è eseguito all’interno dell’evento DOMContentLoaded, è comunque necessario
     * utilizzare jQuery.ready() perché anche Slick viene inizializzato all'interno di jQuery.ready().
     */
    jQuery(document).ready(function($) {
        document.querySelectorAll("ayg-theme-slider-popup").forEach(slider => {
            const $videos = $(slider).find(".ayg-videos");

            $videos.slick("slickSetOption", "slidesToShow", 3, true);
            $videos.slick("slickSetOption", "slidesToScroll", 1, true);
            $videos.slick("slickSetOption", "responsive", responsiveOption, true);
        });
    });
};
